export default __webpack_public_path__ + "static/media/logo-edc.8e13238a.svg";